export const NAME_NOW = 'now'
export const NAME_NOW_EXPEDITION_SHEET_LIST = 'now-expedition-sheet-list'
export const NAME_NOW_DELIVERY_LIST = 'now-delivery-list'
export const NAME_NOW_ONE = 'now-one'

export default [
  {
    path: '/now',
    name: NAME_NOW,
    component: () => import('@/views/pages/Now/Now.vue'),
    meta: {
      layout: 'app',
      needUserLogged: true,
    },
  },
  {
    path: '/now/expedition_sheet/list',
    name: NAME_NOW_EXPEDITION_SHEET_LIST,
    component: () => import('@/views/pages/Now/NowExpeditionSheetList.vue'),
    meta: {
      layout: 'app',
      needUserLogged: true,
    },
  },
  {
    path: '/now/delivery/list',
    name: NAME_NOW_DELIVERY_LIST,
    component: () => import('@/views/pages/Now/NowDeliveryList.vue'),
    meta: {
      layout: 'app',
      needUserLogged: true,
    },
  },
  {
    path: '/now/one/:crop_id',
    name: NAME_NOW_ONE,
    component: () => import('@/views/pages/Now/NowOne.vue'),
    meta: {
      layout: 'app',
      needUserLogged: true,
    },
  },
]
